<template>
  <div class="split-record-manage">
    <!-- 面包屑导航 -->
    <!-- 卡片容器 -->
    <el-card>
      <!-- 搜索表单 -->
      <div class="filter-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
          <el-form-item label="订单号" prop="orderNo">
            <el-input
              v-model="queryParams.orderNo"
              placeholder="请输入订单号"
              clearable
              style="width: 200px;"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="商户ID" prop="merchantId">
            <el-input
              v-model="queryParams.merchantId"
              placeholder="请输入商户ID"
              clearable
              style="width: 200px;"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="分账状态" prop="splitStatus">
            <el-select v-model="queryParams.splitStatus" placeholder="请选择分账状态" clearable style="width: 200px;">
              <el-option
                v-for="dict in splitStatusDict"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="dateRange"
              style="width: 240px"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
            <el-button type="warning" icon="el-icon-s-finance" @click="handleBatchSplit" :disabled="multiple">批量分账</el-button>
            <el-button type="success" icon="el-icon-unlock" @click="handleBatchUnfreeze" :disabled="multiple">批量解冻</el-button>
            <el-button type="success" icon="el-icon-edit" @click="handleManualSplitDialog">手动分账</el-button>
          </el-form-item>
        </el-form>
      </div>

    <!-- 表格 -->
	  <el-table v-loading="loading" :data="splitRecordList" @selection-change="handleSelectionChange" border stripe>
		<el-table-column type="selection" width="55" align="center" />
		<el-table-column type="index" width="60" align="center" />
		<el-table-column label="订单号" align="center" prop="orderNo"/>
		<el-table-column label="订单金额" align="center" prop="originalAmount">
			<template slot-scope="scope">
				{{ scope.row.originalAmount ? '¥' + scope.row.originalAmount : '-' }}
			</template>
		</el-table-column>
		<el-table-column label="分账状态" align="center" prop="splitStatus">
			<template slot-scope="scope">
				<span :style="{ color: scope.row.splitStatus === 1 ? '#67C23A' : scope.row.splitStatus === 2 ? '#F56C6C' : '#909399' }">{{ getDictLabel(splitStatusDict, scope.row.splitStatus) }}</span>
			</template>
		</el-table-column>
    <el-table-column label="分账情况" align="center" prop="failReason"/>
		<el-table-column label="分账时间" align="center" prop="splitTime" width="180">
			<template slot-scope="scope">
				<span>{{ formatTime(scope.row.splitTime) }}</span>
			</template>
		</el-table-column>
		<el-table-column label="创建时间" align="center" prop="createTime" width="180">
			<template slot-scope="scope">
				<span>{{ formatTime(scope.row.createTime) }}</span>
			</template>
		</el-table-column>
		<el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="280">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-view"
              @click="handleDetail(scope.row)"
            >详情</el-button>
            <el-button
              size="mini"
              :type="scope.row.splitStatus === 1 ? 'info' : 'warning'"
              icon="el-icon-s-finance"
              @click="handleSplit(scope.row)"
              :disabled="scope.row.splitStatus === 1"
            >分账</el-button>
            <el-button
              size="mini"
              :type="scope.row.splitStatus === 1 ? 'info' : 'success'"
              icon="el-icon-unlock"
              @click="handleUnfreeze(scope.row)"
              :disabled="scope.row.splitStatus === 1"
            >解冻</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.page"
        :page-sizes="[10, 20, 30, 50,200,500]"
        :page-size="queryParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 分账记录详情对话框 -->
    <el-dialog title="分账记录详情" :visible.sync="detailOpen" width="700px" append-to-body>
      <el-descriptions :column="2" border class="detail-descriptions">
        <el-descriptions-item label="记录ID" label-class-name="detail-label">{{ detailForm.id }}</el-descriptions-item>
        <el-descriptions-item label="订单号" label-class-name="detail-label">{{ detailForm.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="商户ID" label-class-name="detail-label">{{ detailForm.merchantId }}</el-descriptions-item>
        <el-descriptions-item label="订单金额" label-class-name="detail-label">
          <span class="amount-text">{{ detailForm.orderAmount ? '¥' + detailForm.orderAmount : '-' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="分账状态" label-class-name="detail-label">
          <el-tag :type="detailForm.splitStatus === '1' ? 'success' : detailForm.splitStatus === '2' ? 'danger' : 'info'">
            {{ getDictLabel(splitStatusDict, detailForm.splitStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="分账时间" label-class-name="detail-label">{{ formatTime(detailForm.splitTime) }}</el-descriptions-item>
        <el-descriptions-item label="创建时间" label-class-name="detail-label">{{ formatTime(detailForm.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间" label-class-name="detail-label">{{ formatTime(detailForm.updateTime) }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2" label-class-name="detail-label">{{ detailForm.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      
      <el-divider content-position="left">分账明细</el-divider>
      <el-table :data="detailForm.splitDetails" style="width: 100%" border>
        <el-table-column prop="splitType" label="分账类型" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.splitType === '1' ? 'success' : scope.row.splitType === '2' ? 'warning' : 'primary'">
              {{ getDictLabel(splitTypeDict, scope.row.splitType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="targetId" label="目标ID" align="center" />
        <el-table-column prop="targetName" label="目标名称" align="center" />
        <el-table-column prop="splitAmount" label="分账金额" align="center">
          <template slot-scope="scope">
            <span class="amount-text">{{ scope.row.splitAmount ? '¥' + scope.row.splitAmount.toFixed(2) : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="splitRatio" label="分账比例" align="center">
          <template slot-scope="scope">
            <span class="ratio-text">{{ scope.row.splitRatio ? (scope.row.splitRatio * 100).toFixed(2) + '%' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="splitStatus" label="分账状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.splitStatus === '1' ? 'success' : scope.row.splitStatus === '2' ? 'danger' : 'info'">
              {{ getDictLabel(splitStatusDict, scope.row.splitStatus) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 手动分账对话框 -->
    <el-dialog title="手动分账" :visible.sync="manualSplitOpen" width="500px" append-to-body>
      <el-form :model="manualSplitForm" ref="manualSplitForm" :rules="manualSplitRules" label-width="100px">
        <el-form-item label="订单号" prop="orderNo">
          <el-input v-model="manualSplitForm.orderNo" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="操作说明">
          <div style="color: #909399; font-size: 12px; line-height: 1.8;">
            <p>1. 系统将根据订单号查询对应的支付流水</p>
            <p>2. 如果商户已配置分账规则，将执行分账操作</p>
            <p>3. 如果商户未配置分账规则，将执行资金解冻操作</p>
            <p>4. 已完成分账/解冻的订单不会重复处理</p>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="manualSplitOpen = false">取 消</el-button>
        <el-button type="primary" @click="handleManualSplitSubmit" :loading="manualSplitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: "SplitRecordManage",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 分账记录表格数据
      splitRecordList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示详情弹出层
      detailOpen: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        page: 1,
        limit: 10,
        orderNo: null,
        merchantId: null,
        splitStatus: null,
      },
      // 表单参数
      form: {},
      // 详情表单参数
      detailForm: {},
      // 表单校验
      rules: {
        orderNo: [
          { required: true, message: "订单号不能为空", trigger: "blur" }
        ],
        merchantId: [
          { required: true, message: "商户ID不能为空", trigger: "blur" }
        ],
        orderAmount: [
          { required: true, message: "订单金额不能为空", trigger: "blur" }
        ],
        splitStatus: [
          { required: true, message: "分账状态不能为空", trigger: "change" }
        ]
      },
      // 静态字典数据
      splitStatusDict: [
        { label: '待分账', value: 0 },
        { label: '分账成功', value: 1 },
        { label: '分账失败', value: 2 }
      ],
      splitTypeDict: [
        { label: '商户分账', value: 1 },
        { label: '代理商分账', value: 2 },
        { label: '平台分账', value: 3 }
      ],
      // 手动分账弹窗
      manualSplitOpen: false,
      manualSplitLoading: false,
      manualSplitForm: {
        orderNo: ''
      },
      manualSplitRules: {
        orderNo: [
          { required: true, message: '请输入订单号', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询分账记录列表 */
    getList() {
      this.loading = true;
      const requestData = this.addDateRange(this.queryParams, this.dateRange);
      this.$http.post('/split/record/page', requestData).then(response => {
        if (response.data.code === 200) {
          this.splitRecordList = response.data.data.list;
          this.total = response.data.data.total;
        } else {
          this.$message.error(response.data.msg || '获取数据失败');
        }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        orderNo: null,
        merchantId: null,
        orderAmount: null,
        splitStatus: "0",
        remark: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 详情按钮操作 */
    handleDetail(row) {
      this.detailForm = row;
      // 获取分账明细
      if (row.id) {
        this.$http.get('/split/record/' + row.id + '/details').then(response => {
          if (response.data.code === 200) {
            this.detailForm.splitDetails = response.data.rows;
          } else {
            this.$message.error(response.data.msg || '获取分账明细失败');
          }
        }).catch(error => {
          this.$message.error('获取分账明细失败');
        });
      }
      this.detailOpen = true;
    },
    /** 手动分账按钮操作 */
    handleSplit(row) {
      if (row.splitStatus === 1) {
        this.$message.warning('该订单已完成分账');
        return;
      }
      this.$confirm('确认要对该订单执行手动分账吗？订单号：' + row.orderNo + '，订单金额：¥' + row.originalAmount, '分账确认', {
        confirmButtonText: '确认分账',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http.post('/split/record/manual/' + row.id).then(response => {
          this.loading = false;
          if (response.data.code === 200) {
            this.$message.success('分账请求已提交，请稍后刷新查看结果');
            this.getList();
          } else {
            this.$message.error(response.data.msg || '分账失败');
          }
        }).catch(error => {
          this.loading = false;
          this.$message.error('分账请求失败');
        });
      }).catch(() => {});
    },
    /** 解冻剩余资金按钮操作 */
    handleUnfreeze(row) {
      if (row.splitStatus === 1) {
        this.$message.warning('该订单已完成分账/解冻');
        return;
      }
      this.$confirm('确认要解冻该订单的剩余资金吗？订单号：' + row.orderNo + '，订单金额：¥' + row.originalAmount + '\n\n注意：此操作将解冻全部剩余资金到子商户账户，请确认是否继续。', '解冻确认', {
        confirmButtonText: '确认解冻',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http.post('/split/record/unfreeze/' + row.id).then(response => {
          this.loading = false;
          if (response.data.code === 200) {
            this.$message.success('解冻成功');
            this.getList();
          } else {
            this.$message.error(response.data.msg || '解冻失败');
          }
        }).catch(error => {
          this.loading = false;
          this.$message.error('解冻请求失败');
        });
      }).catch(() => {});
    },
    /** 批量分账按钮操作 */
    handleBatchSplit() {
      const selectedRows = this.splitRecordList.filter(item => this.ids.includes(item.id));
      const cannotSplit = selectedRows.filter(item => item.splitStatus === 1);
      
      if (cannotSplit.length > 0) {
        this.$message.warning('已选中的记录中有' + cannotSplit.length + '条已完成分账，请重新选择');
        return;
      }
      
      this.$confirm('确认要对选中的 ' + this.ids.length + ' 条记录执行批量分账吗？', '批量分账确认', {
        confirmButtonText: '确认分账',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http.post('/split/record/batch/manual', this.ids).then(response => {
          this.loading = false;
          if (response.data.code === 200) {
            this.$message.success('批量分账请求已提交，成功：' + (response.data.data.successCount || 0) + ' 条，失败：' + (response.data.data.failCount || 0) + ' 条');
            this.getList();
          } else {
            this.$message.error(response.data.msg || '批量分账失败');
          }
        }).catch(error => {
          this.loading = false;
          this.$message.error('批量分账请求失败');
        });
      }).catch(() => {});
    },
    /** 批量解冻按钮操作 */
    handleBatchUnfreeze() {
      const selectedRows = this.splitRecordList.filter(item => this.ids.includes(item.id));
      const cannotUnfreeze = selectedRows.filter(item => item.splitStatus === 1);
      
      if (cannotUnfreeze.length > 0) {
        this.$message.warning('已选中的记录中有' + cannotUnfreeze.length + '条已完成分账/解冻，请重新选择');
        return;
      }
      
      this.$confirm('确认要对选中的 ' + this.ids.length + ' 条记录执行批量解冻吗？\n\n注意：此操作将解冻全部剩余资金到子商户账户。', '批量解冻确认', {
        confirmButtonText: '确认解冻',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http.post('/split/record/batch/unfreeze', this.ids).then(response => {
          this.loading = false;
          if (response.data.code === 200) {
            this.$message.success('批量解冻完成，成功：' + (response.data.data.successCount || 0) + ' 条，失败：' + (response.data.data.failCount || 0) + ' 条');
            this.getList();
          } else {
            this.$message.error(response.data.msg || '批量解冻失败');
          }
        }).catch(error => {
          this.loading = false;
          this.$message.error('批量解冻请求失败');
        });
      }).catch(() => {});
    },
    /** 根据字典值获取标签 */
    getDictLabel(dictList, value) {
      const dict = dictList.find(item => item.value === value);
      return dict ? dict.label : value;
    },
    /** 格式化时间 */
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    /** 添加日期范围参数 */
    addDateRange(params, dateRange) {
      const search = params;
      search.beginTime = "";
      search.endTime = "";
      if (dateRange != null && dateRange.length === 2) {
        search.beginTime = this.formatTime(dateRange[0]);
        search.endTime = this.formatTime(dateRange[1]);
      }
      return search;
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('/split/record/export', {
        ...this.queryParams
      }, `splitRecord_${new Date().getTime()}.xlsx`)
    },
    /** 分页每页条数改变 */
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    /** 分页当前页改变 */
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    /** 对话框关闭事件 */
    handleDialogClose() {
      this.reset();
    },
    /** 打开手动分账弹窗 */
    handleManualSplitDialog() {
      this.manualSplitForm = {
        orderNo: ''
      };
      this.manualSplitOpen = true;
    },
    /** 提交手动分账 */
    handleManualSplitSubmit() {
      this.$refs.manualSplitForm.validate(valid => {
        if (valid) {
          this.manualSplitLoading = true;
          this.$http.post('/multi/merchant/split/manualSplitOrUnfreeze?orderNo=' + this.manualSplitForm.orderNo).then(response => {
            this.manualSplitLoading = false;
            if (response.data.code === 200) {
              this.$message.success(response.data.msg || '操作成功');
              this.manualSplitOpen = false;
              this.getList();
            } else {
              this.$message.error(response.data.msg || '操作失败');
            }
          }).catch(error => {
            this.manualSplitLoading = false;
            this.$message.error('操作请求失败');
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}
.filter-container .el-form-item {
  margin-bottom: 10px;
}

/* 表格样式增强 */
.el-table {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

/* 详情对话框样式增强 */
.detail-descriptions {
  margin-bottom: 20px;
}

.detail-label {
  font-weight: 600;
  color: #606266;
  background-color: #f5f7fa !important;
}

.amount-text {
  color: #E6A23C;
  font-weight: 600;
}

.ratio-text {
  color: #409EFF;
  font-weight: 600;
}
</style>